import store from '../store/index';
var request = require('request');
var contextInstance = require('./ContextInstance.js').default;
var settingsInstance = require('./SettingsInstance.js');

export function mergeQueryParams(parameters, queryParameters) {
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      var parameter = parameters.$queryParameters[parameterName];
      queryParameters[parameterName] = parameter;
    });
  }
  return queryParameters;
}

export function customRequest(
  method,
  path,
  url,
  body,
  headers,
  queryParameters,
  form,
  deferred,
  files,
  options
) {
  let statusCallbacks = {
    401: _ => {
      contextInstance.login();
    },
    403: _ => contextInstance.setGlobalErrorData(403),
    404: _ => contextInstance.setGlobalErrorData(404),
    409: _ => contextInstance.setGlobalErrorData(409),
    500: _ => contextInstance.setGlobalErrorData(500)
  };

  let req = {
    method: method,
    uri: url,
    qs: queryParameters,
    headers: headers
  };
  if (body) {
    req = { ...req, body: body };
  }

  if (typeof body === 'object' && !(body instanceof Buffer)) {
    req.json = true;
  }

  if (options && options.encoding) {
    req.encoding = options.encoding;
  }

  req.formData = new FormData();

  if (options && options.multipleFiles) {
    for (let i = 0; i < files.length; i++) {
      req.formData.append('file', files[i]);
    }
  } else {
    if (Object.keys(files).length > 0) {
      for (var formKey in form) {
        req.formData.append(formKey, form[formKey]);
      }
      for (var fileKey in files) {
        req.formData.append(fileKey, files[fileKey]);
      }
    } else if (Object.keys(form).length > 0) {
      req.form = form;
    }
  }

  let csrfToken = contextInstance.getCsrfToken();

  req.headers['X-CSRFToken'] = csrfToken;

  req.withCredentials = true;

  if (options != undefined && options.withCredentials != undefined) {
    req.withCredentials = options.withCredentials;
  }
  if (options != undefined && options.hasCsrfToken == false) {
    delete req.headers['X-CSRFToken'];
  }
  if (options != undefined && options.hasContentType == false) {
    delete req.headers['Accept'];
  }
  const showGlobalErrors = !options || (options && !options.ignoreGlobalErrors);
  if (req.formData) {
    var url = req.uri;
    if (Object.keys(req.qs).length > 0) {
      url += '?';
      for (var qsKey in req.qs) {
        let qs = qsKey + '=' + encodeURIComponent(req.qs[qsKey]);
        url += url.slice(-1) === '?' ? qs : '&' + qs;
      }
    }
    var xhr = new XMLHttpRequest();
    if (options && options.download) {
      xhr.responseType = 'blob';
    }

    if (options && options.cancelToken) {
      req.cancelToken = options.cancelToken;
      req.cancelToken.cancel = function() {
        xhr.abort();
        deferred.reject(new Error('Cancelled by user'));
      };
    }

    xhr.onload = _ => {
      var body;

      if (
        xhr.responseType === 'blob' &&
        xhr.status >= 200 &&
        xhr.status <= 299
      ) {
        const blob = xhr.response;

        const blobUrl = URL.createObjectURL(blob);

        // Create a download link
        const link = document.createElement('a');
        link.href = blobUrl;

        // Create file name
        const contentDispositionHeader = xhr.getResponseHeader(
          'Content-Disposition'
        );
        const contentTypeHeader = xhr.getResponseHeader('Content-Type');
        let filename = '';

        if (contentDispositionHeader) {
          const matches = contentDispositionHeader.match(
            /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/i
          );

          if (matches && matches.length > 1) {
            filename = matches[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);

        // Check if the content type includes UTF-8 encoding
        if (
          (contentTypeHeader && contentTypeHeader.includes('charset=UTF-8')) ||
          (options && options.charsetUtf8)
        ) {
          // Read the blob content as text
          const reader = new FileReader();
          reader.onloadend = function() {
            const text = reader.result;

            // Convert the text content to a Uint8Array with UTF-8 encoding
            const encoder = new TextEncoder();
            const utf8Array = encoder.encode(text);

            // Create a new Uint8Array with UTF-8 BOM
            const utf8Bom = new Uint8Array([0xef, 0xbb, 0xbf]);

            // Concatenate the BOM and the UTF-8 encoded content
            const utf8Content = new Uint8Array(
              utf8Bom.length + utf8Array.length
            );
            utf8Content.set(utf8Bom);
            utf8Content.set(utf8Array, utf8Bom.length);

            // Create a new Blob with the UTF-8 encoded content
            const utf8Blob = new Blob([utf8Content], {
              type: 'text/plain;charset=utf-8'
            });

            // Set the new Blob as the download link source
            link.href = URL.createObjectURL(utf8Blob);

            // Click the link to download the file
            link.click();

            // Clean up
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
          };

          reader.readAsText(blob, 'utf-8');
        } else {
          // Click the link to download the file (without encoding changes)
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        }
      }

      if (xhr.response) {
        try {
          body = JSON.parse(xhr.response);
        } catch (e) {}
      }
      if (statusCallbacks[xhr.status] && showGlobalErrors) {
        statusCallbacks[xhr.status]();
      } else if (xhr.status >= 200 && xhr.status <= 299) {
        contextInstance.clearGlobalError();
        if (xhr.responseType == 'blob') {
        } else {
          deferred.resolve({
            response: xhr.response,
            body: body
          });
        }
      } else {
        contextInstance.clearGlobalError();

        deferred.reject({
          response: xhr.response,
          body: body
        });
      }
    };
    xhr.upload.onerror = error => {
      deferred.reject({
        response: error
      });
    };
    xhr.upload.onprogress = progress => {
      deferred.notify(Math.round((progress.loaded * 100) / progress.total));
    };

    xhr.open(req.method, url);
    xhr.setRequestHeader('X-CSRFToken', csrfToken);

    if (req.headers['wso2_id'] != undefined) {
      xhr.setRequestHeader('wso2_id', req.headers['wso2_id']);
    }
    if (req.headers['orgid'] != undefined) {
      xhr.setRequestHeader('orgid', req.headers['orgid']);
    }

    if (req.form && options.jsonData) {
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.send(JSON.stringify(req.form));
      return;
    } else if (req.body && options && options.jsonData) {
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.send(JSON.stringify(req.body));
      return;
    }
    xhr.withCredentials = true;
    xhr.send(req.formData);
  } else {
    request(req, function(error, response, body) {
      if (error) {
        deferred.reject(error);
      } else {
        if (
          /^application\/(.*\\+)?json/.test(response.headers['content-type'])
        ) {
          try {
            body = JSON.parse(body);
          } catch (e) {}
        }

        // const showNotFoundError =
        //   !options ||
        //   (options &&
        //     !options.ignoreNotFoundErrors &&
        //     response.statusCode == 404);
        // const showGlobalErrors =
        //   !options ||
        //   (options && !options.ignoreGlobalErrors && showNotFoundError);

        if (statusCallbacks[response.statusCode] && showGlobalErrors) {
          statusCallbacks[response.statusCode]();
        } else if (response.statusCode === 204) {
          contextInstance.clearGlobalError();

          deferred.resolve({
            response: response
          });
        } else if (response.statusCode >= 200 && response.statusCode <= 299) {
          contextInstance.clearGlobalError();

          if (body == 'Włączono tryb tylko od odczytu') {
            store.commit('setReadonlyMode', {
              enabled: true
            });
            if (response.request.method != 'GET') {
              deferred.reject({
                body: {
                  error: 'Włączono tryb tylko do odczytu'
                }
              });
            } else {
              deferred.resolve({
                response: response,
                body: body
              });
            }
          } else {
            deferred.resolve({
              response: response,
              body: body
            });
          }
        } else {
          contextInstance.clearGlobalError();

          deferred.reject({
            response: response,
            body: body
          });
        }
      }
    });
  }
}
